import { z } from "zod";
import {
  DomainModelMetaExtendedSchema,
  DomainModelMetaSchema,
  DomainModelSchema,
} from "../util/index.ts";

export const SavedFilterStatus = {
  ACTIVE: "active",
  DRAFT: "draft",
} as const;
export type SavedFilterStatusType =
  (typeof SavedFilterStatus)[keyof typeof SavedFilterStatus];

export const createSavedFilterSchema = <T extends z.ZodTypeAny>(
  filterSchema: T
) =>
  z
    .object({
      name: z.string(),
      status: z.nativeEnum(SavedFilterStatus),
      filter: filterSchema, // Use the generic schema here
      group_by: z.array(z.string()).optional(),
      metadata: z.array(z.record(z.any())).optional(),
    })
    .merge(DomainModelSchema)
    .merge(DomainModelMetaSchema)
    .merge(DomainModelMetaExtendedSchema);

export type SavedFilterType<T extends z.ZodTypeAny> = z.infer<
  ReturnType<typeof createSavedFilterSchema<T>>
>;
